import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isRequiredIf from 'react-proptype-conditional-require';
import styles from './styles.scss';

class Slide extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    position: PropTypes.number,
    isActive: PropTypes.bool,
    activeItem: PropTypes.number,
    registerNodeDetails: PropTypes.func,
    reregisterItems: PropTypes.number,
    isObscured: PropTypes.bool,
    minWidth: PropTypes.number,
    isDisabled: PropTypes.bool,
    id: PropTypes.string,
    className: PropTypes.string,
    lazyLoader: PropTypes.shape({
      isSupported: PropTypes.bool.isRequired,
      observe: isRequiredIf(PropTypes.func, (props) => props.isSupported),
      unobserve: isRequiredIf(PropTypes.func, (props) => props.isSupported),
    }),
    disableOpacity: PropTypes.bool,
  };

  static defaultProps = {
    isActive: true,
    position: 0,
    activeItem: 0,
    registerNodeDetails: () => {},
    reregisterItems: 0,
    isObscured: false,
    minWidth: null,
    isDisabled: false,
    id: '',
    className: '',
    lazyLoader: undefined,
    disableOpacity: false,
  };

  constructor(props) {
    super(props);
    this.registerNode = this.registerNode.bind(this);
  }

  componentDidMount() {
    this.registerNode();
  }

  componentDidUpdate(prevProps) {
    const { activeItem, reregisterItems } = this.props;
    if (activeItem !== prevProps.activeItem || reregisterItems !== prevProps.reregisterItems) {
      this.registerNode();
    }
  }

  registerNode() {
    const { registerNodeDetails, id, position, isActive } = this.props;
    registerNodeDetails({
      id: id || `slide${position}`,
      node: this.slide,
      active: isActive,
      position,
    });
  }

  render() {
    const {
      minWidth,
      className,
      isObscured,
      isActive,
      isDisabled,
      children,
      id,
      lazyLoader,
      disableOpacity,
    } = this.props;

    const style = minWidth
      ? {
          minWidth,
        }
      : null;

    const slideClasses = classNames(styles['list-item'], className, {
      [styles.fade]: (isObscured && !isActive && !disableOpacity) || isDisabled,
    });

    return (
      <li
        ref={(li) => {
          this.slide = li;
        }}
        className={slideClasses}
        style={style}
        key={id}
      >
        {React.cloneElement(children, {
          isActive,
          lazyLoader,
        })}
      </li>
    );
  }
}

export default Slide;
